import { Injector } from '@angular/core';
import { ColorModeService } from '@core/services/color-mode.service';
import { DebugService } from '@core/services/debug/debug.service';

export interface KeyboardShortcutCombo {
  /** e.g. `'meta+shift+l'` */
  mac: string;
  /** e.g. `'ctrl+shift+l'` */
  winLinux: string;
}

export interface KeyboardShortcutDefinition {
  id: string;
  keys: KeyboardShortcutCombo;
  description: string;
  run: (injector: Injector) => void;
}

export const KEYBOARD_SHORTCUTS: readonly KeyboardShortcutDefinition[] = [
  {
    id: 'toggle-dark-mode',
    keys: { mac: 'meta+shift+d', winLinux: 'ctrl+shift+d' },
    description: 'Alternar modo escuro',
    run: (injector) => injector.get(ColorModeService).toggle(),
  },
  {
    id: 'open-debug-menu',
    keys: { mac: 'meta+shift+alt+d', winLinux: 'ctrl+shift+alt+d' },
    description: 'Abrir menu do desenvolvedor',
    run: (injector) => void injector.get(DebugService).openDebugMenu(),
  },
];
